import { getBlogPostPreviewImage } from "@compass/shared/utils";
import ArticlePlaceholder from "assets/img/icons/sidebar/article-placeholder.svg?react";
import LatesArticlesIcon from "assets/img/icons/sidebar/lates-articles.svg?react";
import { Spinner } from "components/elements";
import { ResponsiveImage } from "components/elements/ResponsiveImage";
import { trpc } from "lib/trpc";

export const LatestArticlesSidebar = () => {
    const {
        data,
        isPending: isLoading,
        isError,
    } = trpc.resources.latestPosts.useQuery({
        page: 1,
        limit: 15,
    });

    if (isLoading) {
        return (
            <div className="text-center text-sm text-gray-500">
                <Spinner className="mx-auto" />
            </div>
        );
    }

    if (!data || "error" in data) {
        return <div className="text-center text-sm text-red-500">No articles available.</div>;
    }

    const posts = data.posts.slice(0, 3);

    return (
        <div className="my-6 rounded-2xl border border-[#c8c8c8] bg-white p-4 shadow-none">
            {/* Header */}
            <div className="mb-2 flex items-center gap-2">
                <span className="text-blue-600">
                    <LatesArticlesIcon />
                </span>
                <h2 className="font-sans text-xl leading-[24px] font-bold text-[#424242]">
                    Latest articles in Compass
                </h2>
            </div>
            <p className="text-md mb-4 text-gray-500">The most important recent articles</p>

            <div className="flex flex-col gap-4">
                {posts.map((post) => {
                    const thumbnail = getBlogPostPreviewImage(post.preview);
                    const objectFitClass =
                        post.previewFit === "contain" ? "object-contain" : "object-cover";
                    const objectPositionStyle =
                        post.previewFit === "manual"
                            ? {
                                  objectPosition: `${post.previewPositionX ?? 50}% ${post.previewPositionY ?? 50}%`,
                              }
                            : undefined;
                    return (
                        <a
                            key={post.id}
                            href={`/p/${post.slug}`}
                            className="flex items-start gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3 no-underline transition-colors hover:bg-gray-100"
                        >
                            {/* Image */}
                            <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md bg-blue-100">
                                {thumbnail ? (
                                    <ResponsiveImage
                                        image={thumbnail}
                                        sizes="64px"
                                        alt={post.title}
                                        className={`h-full w-full ${objectFitClass}`}
                                        style={objectPositionStyle}
                                    />
                                ) : (
                                    <div className="flex h-full w-full items-center justify-center text-gray-400">
                                        <ArticlePlaceholder />
                                    </div>
                                )}
                            </div>

                            {/* Text content */}
                            <div className="flex flex-1 flex-col">
                                <h3 className="font-sans text-[14px] leading-normal font-semibold text-[#424242]">
                                    {post.title}
                                </h3>
                                <p className="mb-1.5 font-sans text-[10px] leading-normal font-light text-[#2A2625]">
                                    {post.excerpt?.replace(/<[^>]+>/g, "")?.slice(0, 90) || ""}
                                </p>

                                <div className="flex items-center justify-between">
                                    <span className="rounded-md bg-sky-500 px-3 py-1 font-sans text-[10px] leading-normal font-bold text-[#FAFFFE]">
                                        Read More
                                    </span>
                                </div>
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};
